import request from '@/utils/request'


export function queryVccConsume(data) {
  return request({
    url: '/admin/consume/queryVccConsume',
    method: 'post',
    data: data
  })
}


export function queryCardConsume(data) {
  return request({
    url: '/admin/consume/queryCardConsume',
    method: 'post',
    data: data
  })
}

export function queryShopConsume(data) {
  return request({
    url: '/admin/consume/queryShopConsume',
    method: 'post',
    data: data
  })
}

/**
 * 查询撤销记录
 * @param data
 */
export function queryRevokeCardConsume(data) {
  return request({
    url: '/admin/consume/queryRevokeCardConsume',
    method: 'post',
    data: data
  })
}

/**
 * 撤销操作
 * @param data
 */
export function revokeCardConsume(data) {
  return request({
    url: '/admin/consume/revokeCardConsume',
    method: 'post',
    data: data
  })
}

/**
 * 撤销商品消费
 * @param data
 */
 export function revokeShopConsume(data) {
  return request({
    url: '/admin/consume/revokeShopConsume',
    method: 'post',
    data: data
  })
}
















// WEBPACK FOOTER //
// ./src/api/ConsumeRecord.js